module.exports = __webpack_public_path__ + "static/img/msg-box-warning.bf91a7b9.svg";